"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iFrameScript = iFrameScript;
exports.websiteIframeScript = websiteIframeScript;
exports.ampIframeScript = ampIframeScript;

var _iframe = require("./iframe.paths");

var _config = _interopRequireDefault(require("../config"));

var _iframe2 = require("./iframe.utils");

var _iframe3 = require("../models/iframe");

var _iframeCallbacks;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var iframeCallbacks = (_iframeCallbacks = {}, _defineProperty(_iframeCallbacks, _iframe3.IframeType.Website, websiteIframeScript), _defineProperty(_iframeCallbacks, _iframe3.IframeType.Amp, ampIframeScript), _iframeCallbacks);

function iFrameScript(widgetId, scriptType) {
  var iframeUrl = "".concat(_config["default"].APP_URL).concat((0, _iframe.getIframePath)(widgetId));
  var height = (0, _iframe2.getWidgetHeight)();
  return iframeCallbacks[scriptType](widgetId, iframeUrl, height);
}

function websiteIframeScript(widgetId, iframeUrl, height) {
  return "\n\t\t <div id=\"".concat(widgetId, "\" class=\"dot-widget\" data-url=\"").concat(iframeUrl, "\" data-height=\"").concat(height, "\"></div><script async src=\"").concat(_config["default"].APP_URL, "/dot-widget.js\"></script>\n\t").trim();
}

function ampIframeScript(widgetId, iframeUrl, height) {
  return "\n\t\t<amp-iframe src=\"".concat(iframeUrl, "?iframeType=amp\" height=\"").concat(height, "\" sandbox=\"allow-scripts allow-same-origin allow-top-navigation\" layout=\"fixed-height\"><amp-img width=\"600\" height=\"315\" layout=\"fill\" src=\"https://dotaudiences.com/dot-logo-grey.png\" placeholder></amp-img></amp-iframe>\n\t").trim();
}